import { ChangeEvent, FC, useEffect, useState } from 'react'
import * as Yup from 'yup'
import { useFormik } from 'formik'
import { isNotEmpty, toAbsoluteUrl } from '../../../../../_metronic/helpers'
import { initialServiceCategory, ServiceCategory } from '../core/_models'
import clsx from 'clsx'
import { useListView } from '../core/ListViewProvider'
import { ServiceCategoriesListLoading } from '../components/loading/ServiceCategoriesListLoading'
import { createServiceCategory, updateServiceCategory } from '../core/_requests'
import { useQueryResponse } from '../core/QueryResponseProvider'
import { FormattedMessage, useIntl } from 'react-intl'
import axios from 'axios'
import { ServiceCategorySubType } from '../../../servicecategorysubtype/servicecategorysubtypes-list/core/_models'

type Props = {
  isServiceCategoryLoading: boolean
  service_category: ServiceCategory
}

const editServiceCategorySchema = Yup.object().shape({
  profile_image_url: Yup.mixed(),
})

const ServiceCategoryEditModalForm: FC<Props> = ({ service_category, isServiceCategoryLoading }) => {
  const intl = useIntl()
  // Function to handle image selection
  const [selectedImage, setSelectedImage] = useState<string | null>(null);

  const { setItemIdForUpdate } = useListView()
  const { refetch } = useQueryResponse()
  const [service_categoryForEdit] = useState<ServiceCategory>({
    ...service_category,
    category_name: service_category.category_name || initialServiceCategory.category_name,
    type: service_category.type || initialServiceCategory.type,
  })
  const API_URL = process.env.REACT_APP_THEME_API_URL;
  const SERVICECATEGORYSUBTYPE_URL = `${API_URL}/admin/service-category-sub-type`;
  const [service_category_sub_types, setServiceCategorySubTypes] = useState<[ServiceCategorySubType]>();

  useEffect(() => {
    // Make the API request using Axios
    axios
      .get(SERVICECATEGORYSUBTYPE_URL)
      .then((response) => {
        const data = response.data;
        if (data.success) {
          setServiceCategorySubTypes(data.data.servicecategorysubtype);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);
  const cancel = (withRefresh?: boolean) => {
    if (withRefresh) {
      refetch()
    }
    setItemIdForUpdate(undefined)
  }

  const formik = useFormik({
    initialValues: service_categoryForEdit,
    validationSchema: editServiceCategorySchema,
    onSubmit: async (values, { setSubmitting }) => {
      console.log("form values", values);
      setSubmitting(true)
      try {
        if (isNotEmpty(values.id)) {
          await updateServiceCategory(values)
        } else {
          await createServiceCategory(values)
        }
      } catch (ex) {
        console.error(ex)
      } finally {
        setSubmitting(true)
        cancel(true)
      }
    },
  })

  return (
    <>
      <form id='kt_modal_add_service_category_form' encType="multipart/form-data" className='form' onSubmit={formik.handleSubmit} noValidate>
        {/* begin::Scroll */}
        <div
          className='d-flex flex-column scroll-y me-n7 pe-7'
          id='kt_modal_add_service_category_scroll'
          data-kt-scroll='true'
          data-kt-scroll-activate='{default: false, lg: true}'
          data-kt-scroll-max-height='auto'
          data-kt-scroll-dependencies='#kt_modal_add_service_category_header'
          data-kt-scroll-wrappers='#kt_modal_add_service_category_scroll'
          data-kt-scroll-offset='300px'
        >
          {/* begin::Input group */}
          <div className='fv-row mb-7'>
            {/* begin::Label */}
            <label className='required fw-bold fs-6 mb-2'><FormattedMessage id='SERVICECATEGORY.FORM.INPUT.SERVICECATEGORYNAME' />
            </label>
            {/* end::Label */}

            {/* begin::Input */}
            <input
              placeholder={intl.formatMessage({ id: 'SERVICECATEGORY.FORM.PLACEHOLDER.SERVICECATEGORYNAME' })}
              {...formik.getFieldProps('category_name')}
              className={clsx(
                'form-control form-control-solid mb-3 mb-lg-0',
                { 'is-invalid': formik.touched.category_name && formik.errors.category_name },
                {
                  'is-valid': formik.touched.category_name && !formik.errors.category_name,
                }
              )}
              type='text'
              name='category_name'
              autoComplete='off'
              disabled={formik.isSubmitting || isServiceCategoryLoading}
            />
            {/* end::Input */}
            {formik.touched.category_name && formik.errors.category_name && (
              <div className='fv-plugins-message-container'>
                {/* <span role='alert'>{formik.errors.language_id}</span> */}
              </div>
            )}
          </div>
          {/* end::Input group */}

          {/* begin::Input group */}

          <div className="fv-row mb-10"><label className="form-label required">
            <FormattedMessage id='SERVICECATEGORY.FORM.INPUT.SERVICECATEGORYTYPE' />
          </label>
            <select
              {...formik.getFieldProps('type')}
              className={clsx(
                'form-select form-select-lg form-select-solid form-control form-control-solid mb-3 mb-lg-0',
                { 'is-invalid': formik.touched.type && formik.errors.type },
                {
                  'is-valid': formik.touched.type && !formik.errors.type,
                }
              )}
              autoComplete='off'
              disabled={formik.isSubmitting || isServiceCategoryLoading}

            ><option value='WorldWide' defaultValue={"WorldWide"}>{intl.formatMessage({ id: 'FORM.GENERAL.SELECT' })}</option>
            <option value='social'>{intl.formatMessage({ id: 'FORM.GENERAL.SELECT.OPTION.SOCIAL' })}</option>
            <option value='nonsocial'>{intl.formatMessage({ id: 'FORM.GENERAL.SELECT.OPTION.NONSOCIAL' })}</option>
            </select>
            {formik.touched.type && formik.errors.type && (
              <div className='fv-plugins-message-container'>
                {/* <span role='alert'>{formik.errors.district_id}</span> */}
              </div>
            )}</div>
          {/* begin::Input group */}

          <div className="fv-row mb-10"><label className="form-label required">
            <FormattedMessage id='COMPANY.FORM.INPUT.COUNTRYNAME' />
          </label>
            <select
              {...formik.getFieldProps('service_category_sub_type_id')}
              className={clsx(
                'form-select form-select-lg form-select-solid form-control form-control-solid mb-3 mb-lg-0',
                { 'is-invalid': formik.touched.service_category_sub_type && formik.errors.service_category_sub_type },
                {
                  'is-valid': formik.touched.service_category_sub_type && !formik.errors.service_category_sub_type,
                }
              )}
              autoComplete='off'
              disabled={formik.isSubmitting || isServiceCategoryLoading}

            ><option value='WorldWide' defaultValue={"WorldWide"}>{intl.formatMessage({ id: 'FORM.GENERAL.SELECT' })}</option>
              {service_category_sub_types && service_category_sub_types.map(service_category_sub_type => (
                <option value={service_category_sub_type.id}>{service_category_sub_type.sub_type_name}</option>
              ))}
            </select>
            {formik.touched.service_category_sub_type && formik.errors.service_category_sub_type && (
              <div className='fv-plugins-message-container'>
                {/* <span role='alert'>{formik.errors.district_id}</span> */}
              </div>
            )}</div>
          {/* end::Input group */}
        </div>
        {/* end::Scroll */}

        {/* begin::Actions */}
        <div className='text-center pt-15'>
          <button
            type='reset'
            onClick={() => cancel()}
            className='btn btn-light me-3'
            data-kt-service_categories-modal-action='cancel'
            disabled={formik.isSubmitting || isServiceCategoryLoading}
          >
            <FormattedMessage id='FORM.GENERAL.DISCARD' />
          </button>

          <button
            type='submit'
            className='btn btn-primary'
            data-kt-service_categories-modal-action='submit'
            disabled={isServiceCategoryLoading || formik.isSubmitting || !formik.isValid || !formik.touched}
          >
            <span className='indicator-label'>Submit</span>
            {(formik.isSubmitting || isServiceCategoryLoading) && (
              <span className='indicator-progress'>
                <FormattedMessage id='FORM.GENERAL.PLEASEWAIT' />
                {' '}
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </button>
        </div>
        {/* end::Actions */}
      </form>
      {(formik.isSubmitting || isServiceCategoryLoading) && <ServiceCategoriesListLoading />}
    </>
  )
}

export { ServiceCategoryEditModalForm }
